import React, { Component } from "react";
import { InfoIconWithMessage } from "../../../shared/infoIcon/InfoIcon";
import { withTranslation } from "react-i18next";
import LeadTimesRow from "./LeadTimesRow";
import Grid from "@material-ui/core/Grid";
import styles from "./LeadTimes.module.scss";
import CheckBox from "../../../shared/checkBox/CheckBox";
import EditIcon from "../../../shared/Edit/EditIcon";
import { ValidatorForm } from "react-material-ui-form-validator";
import HasPermissionTo from "../../../common/HasPermissionTo";
import LeadTimesClient from "../../../shared/clients/LeadTimesClient";
import { LEAD_TIMES } from "../../../common/Constants";
import PendingActionClient from "../../../shared/clients/PendingActionClient";
import ValidationRules from "../../../common/ValidationRules";
import TypeOfVehicleDropdown from "../../pricing/pricingWrapper/depositPricing/modifyReservationPrice/TypeOfVehicleDropdown";
import style from "../../pricing/pricingWrapper/PricingWrapper.module.scss";

class LeadTimes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editUnscheduled: false,
      editInProduction: false,
      editInTransit: false,
      editGateReleased: false,
      editVehicleHoldingCompound: false,
      editDealerDelivered: false,
      data: [],
      firstLoadPV: false,
      firstLoadCV: false,
      firstLoad: false,
      totalChecked: 0,
      editCount: 0,
      buttonDisabled: true,
      saveSuccess: false,
      totalSaved: 0,
      infoTooltipOpen: false,
      infoTooltipColumn: "",
      selectedVehicleType: this.props.t(
        "ModifyReservationPrice.passengerVehicles"
      ),
      leadTimesResponse: {},
      listOfVehicleTypes: [
        this.props.t("ModifyReservationPrice.passengerVehicles"),
        this.props.t("ModifyReservationPrice.commercialVehicles"),
      ],
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.closeInfoTooltip = this.closeInfoTooltip.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.isNotFirstLoad = this.isNotFirstLoad.bind(this);

    this.displayLeadTimesInfo =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "displayLeadTimesInfo"
      );
  }

  componentDidMount() {
    ValidationRules();
    this.fetchLeadTimes([]);
  }

  onTypeOfVehicleChange = (event) => {
    event.preventDefault();
    const vehicleType = event.target.value;
    const filterBy =
      vehicleType === this.props.t("ModifyReservationPrice.commercialVehicles")
        ? "CV"
        : "PV";
    const firstLoad =
      filterBy === "PV" ? this.state.firstLoadPV : this.state.firstLoadCV;

    const filteredData = this.state.leadTimesResponse.filter(
      (item) => item.vehicleType === filterBy
    );
    const checkedCount = filteredData.filter((item) => item.checked).length;
    this.setState({
      selectedVehicleType: vehicleType,
      data: filteredData,
      totalChecked: checkedCount,
      firstLoad,
    });
  };

  handleEdit(key) {
    // Show popup tooltip with info if this is the users first time editing anything on the page
    if (this.state.firstLoad && this.state.editCount === 0) {
      this.setState({ infoTooltipOpen: true, infoTooltipColumn: key });
    }

    // If this is first edit after save, reset all the data
    if (this.state.saveSuccess) {
      const copyData = JSON.parse(JSON.stringify(this.state.data));
      copyData.forEach((item) => {
        item.saved = false;
      });
      this.setState({ saveSuccess: false, data: copyData, totalSaved: 0 });
    }

    switch (key) {
      case "UnscheduleDeliveryTime":
        this.setState(
          {
            editUnscheduled: true,
            editCount: this.state.editCount + 1,
          },
          () => this.checkButtonDisabled()
        );
        break;
      case "InProduction":
        this.setState(
          {
            editInProduction: true,
            editCount: this.state.editCount + 1,
          },
          () => this.checkButtonDisabled()
        );
        break;
      case "GateRelease":
        this.setState(
          {
            editGateReleased: true,
            editCount: this.state.editCount + 1,
          },
          () => this.checkButtonDisabled()
        );
        break;
      case "InTransit":
        this.setState(
          {
            editInTransit: true,
            editCount: this.state.editCount + 1,
          },
          () => this.checkButtonDisabled()
        );
        break;
      case "VehicleHoldCompound":
        this.setState(
          {
            editVehicleHoldingCompound: true,
            editCount: this.state.editCount + 1,
          },
          () => this.checkButtonDisabled()
        );
        break;
      case "DealerDelivery":
        this.setState(
          {
            editDealerDelivered: true,
            editCount: this.state.editCount + 1,
          },
          () => this.checkButtonDisabled()
        );
        break;
      default:
        return;
    }
  }

  handleChange(e, index, key) {
    // Update data
    const dataCopy = JSON.parse(JSON.stringify(this.state.data));
    dataCopy[index]["deliveryStatus"][key] = e.target.value;

    // Check field if first edit
    const wasChecked = dataCopy[index].checked;
    !wasChecked && (dataCopy[index].checked = true);
    this.setState(
      {
        data: dataCopy,
        totalChecked: wasChecked
          ? this.state.totalChecked
          : this.state.totalChecked + 1,
      },
      () => this.checkButtonDisabled()
    );

    // Auto advance
    if (e.target.value.length === 5) {
      this.advanceFields(e);
    }
  }

  handleKeyDown(e) {
    if (e.keyCode === 39) {
      this.advanceFields(e);
    } else if (e.keyCode === 37) {
      this.goBack(e);
    }
  }

  handleSubmit() {
    const totalSaved = this.state.totalChecked;
    const clonedData = JSON.parse(JSON.stringify(this.state.data));
    const savedList = [];
    clonedData.forEach((leadTime) => {
      if (leadTime.checked) {
        savedList.push(leadTime);
      }
    });
    LeadTimesClient.postLeadTimes(this.state.data, this.props.user).then(() => {
      PendingActionClient.removeNscPendingAction(
        this.props.user,
        LEAD_TIMES,
        null,
        this.props.selectedMarket
      );
      this.setState({
        editUnscheduled: false,
        editInProduction: false,
        editGateReleased: false,
        editInTransit: false,
        editVehicleHoldingCompound: false,
        editDealerDelivered: false,
        totalSaved: totalSaved,
        editCount: 0,
        buttonDisabled: true,
        saveSuccess: true,
      });
      this.fetchLeadTimes(savedList);
    });
  }

  fetchLeadTimes(savedList) {
    LeadTimesClient.getLeadTimes(
      this.props.user,
      this.props.selectedMarket
    ).then((response) => {
      const firstLoadPV = !this.isNotFirstLoad(response, "PV");
      const firstLoadCV = !this.isNotFirstLoad(response, "CV");

      response = response.map((lt) => {
        if (lt.vehicleType === "PV") {
          lt.checked = firstLoadPV;
        } else {
          lt.checked = firstLoadCV;
        }
        return lt;
      });

      // Uncheck all after save
      if (savedList.length > 0) {
        savedList.forEach((item) => {
          const index = response.findIndex(
            (leadTime) => leadTime.leadSeq === item.leadSeq
          );
          response[index].saved = true;
          response[index].checked = false;
        });
      }

      const filterBy =
        this.state.selectedVehicleType ===
        this.props.t("ModifyReservationPrice.passengerVehicles")
          ? "PV"
          : "CV";
      const filteredData = response.filter(
        (res) => res.vehicleType === filterBy
      );
      const firstLoad = filterBy === "PV" ? firstLoadPV : firstLoadCV;

      this.setState({
        data: filteredData,
        firstLoad,
        firstLoadCV,
        firstLoadPV,
        totalChecked: firstLoad ? filteredData.length : 0,
        leadTimesResponse: response,
      });
    });
  }

  checkButtonDisabled() {
    if (this.state.firstLoad) {
      // On first load, all fields need to be filled out to enable button - so all must be in edit mode
      this.formRef.current
        .isFormValid()
        .then((valid) => {
          this.setState({
            buttonDisabled: !(valid && this.state.editCount === 6),
          });
        })
        .catch(() => {});
    } else {
      this.formRef.current.isFormValid().then((valid) => {
        this.setState({
          buttonDisabled: !(valid && this.state.totalChecked > 0),
        });
      });
    }
  }

  advanceFields(e) {
    const form = e.target.form;
    const index = Array.prototype.indexOf.call(form, e.target);
    let inputFound = false;
    let next;
    for (let i = index + 1; i < form.elements.length; ++i) {
      if (form.elements[i].type === "text") {
        inputFound = true;
        next = i;
        break;
      }
    }
    if (inputFound) {
      form.elements[next].focus();
      e.preventDefault();
    }
  }

  goBack(e) {
    const form = e.target.form;
    const index = Array.prototype.indexOf.call(form, e.target);
    let inputFound = false;
    let prev;
    for (let i = index - 1; i >= 0; --i) {
      if (form.elements[i].type === "text") {
        inputFound = true;
        prev = i;
        break;
      }
    }
    if (inputFound) {
      form.elements[prev].focus();
      e.preventDefault();
    }
  }

  formRef = React.createRef();

  isNotFirstLoad(leadTimes, filter) {
    const ltFiltered = leadTimes.filter((lt) => lt.vehicleType === filter);
    return ltFiltered.every((lt) => {
      return (
        this.getTrimmedValue(lt.deliveryStatus.UnscheduleDeliveryTime) &&
        this.getTrimmedValue(lt.deliveryStatus.DealerDelivery) &&
        this.getTrimmedValue(lt.deliveryStatus.InProduction) &&
        this.getTrimmedValue(lt.deliveryStatus.GateRelease) &&
        this.getTrimmedValue(lt.deliveryStatus.VehicleHoldCompound) &&
        this.getTrimmedValue(lt.deliveryStatus.InTransit)
      );
    });
  }

  getTrimmedValue(value) {
    return value ? value.trim() : "";
  }

  closeInfoTooltip() {
    this.setState({ infoTooltipOpen: false, infoTooltipColumn: "" });
  }

  getSubHeader = () => {
    return (
      <Grid item md={3} xs={4} className={styles.tovDropdown}>
        <div className={`${style.dropdownContainer}`}>
          <div className={`${style.marketDropDownDiv}`}>
            <p>{this.props.t("ModifyReservationPrice.typeOfVehicle")}</p>
            <TypeOfVehicleDropdown
              selectedVehicleType={this.state.selectedVehicleType}
              listOfVehicleTypes={this.state.listOfVehicleTypes}
              updateVehicleType={this.onTypeOfVehicleChange}
            />
          </div>
        </div>
      </Grid>
    );
  };

  render() {
    const isFromNscDealerSearch =
      this.props.user &&
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "leadTimesSubmit"
      ) &&
      this.props.fromNscDealerSearch;
    return (
      <div className="pageWrapper">
        <div className="pagePaddingTop">
          <div className="pagePaddingLeft pagePaddingRight">
            {this.displayLeadTimesInfo && (
              <InfoIconWithMessage
                message={this.props.t("LeadTimes.subheader")}
              />
            )}
            {this.getSubHeader()}
          </div>
          <div className="pagePaddingTop">
            <div>
              <Grid container spacing={0} className={styles.divider}>
                <Grid item xs={1} className={styles.checkboxHeader}>
                  <div className={styles.checkbox}>
                    <CheckBox
                      id="leadTimesAll"
                      faded={true}
                      checked={
                        this.state.totalChecked === this.state.data.length
                      }
                      isDisabled={true}
                    />
                  </div>
                </Grid>
                <Grid item xs={5} className={styles.descriptionHeader}>
                  {this.props.t("LeadTimes.factoryNo")}
                </Grid>
                <Grid item xs={1} className={styles.editHeader}>
                  <span
                    className={
                      !this.state.editUnscheduled
                        ? styles.negativeMarginTitle
                        : styles.title
                    }
                  >
                    {this.props.t("LeadTimes.unscheduled")}
                  </span>
                  <HasPermissionTo
                    perform={["leadTimes:write"]}
                    permissions={this.props.user.permissions.rolePermissions}
                    condition={
                      !this.state.editUnscheduled &&
                      !this.props.fromNscDealerSearch
                    }
                    render={() => {
                      return (
                        <div className={styles.editIcon}>
                          <EditIcon
                            id="Unscheduled"
                            onClick={() =>
                              this.handleEdit("UnscheduleDeliveryTime")
                            }
                          />
                        </div>
                      );
                    }}
                  />
                </Grid>
                <Grid item xs={1} className={styles.editHeader}>
                  <span
                    className={
                      !this.state.editUnscheduled
                        ? styles.negativeMarginTitle
                        : styles.title
                    }
                  >
                    {this.props.t("LeadTimes.inProduction")}
                  </span>
                  <HasPermissionTo
                    perform={["leadTimes:write"]}
                    permissions={this.props.user.permissions.rolePermissions}
                    condition={
                      !this.state.editInProduction &&
                      !this.props.fromNscDealerSearch
                    }
                    render={() => {
                      return (
                        <div className={styles.editIcon}>
                          <EditIcon
                            id="InProduction"
                            onClick={() => this.handleEdit("InProduction")}
                          />
                        </div>
                      );
                    }}
                  />
                </Grid>
                <Grid item xs={1} className={styles.editHeader}>
                  <span
                    className={
                      !this.state.editUnscheduled
                        ? styles.negativeMarginTitle
                        : styles.title
                    }
                  >
                    {this.props.t("LeadTimes.gateReleased")}
                  </span>
                  <HasPermissionTo
                    perform={["leadTimes:write"]}
                    permissions={this.props.user.permissions.rolePermissions}
                    condition={
                      !this.state.editGateReleased &&
                      !this.props.fromNscDealerSearch
                    }
                    render={() => {
                      return (
                        <div className={styles.editIcon}>
                          <EditIcon
                            id="Gate"
                            onClick={() => this.handleEdit("GateRelease")}
                          />
                        </div>
                      );
                    }}
                  />
                </Grid>
                <Grid item xs={1} className={styles.editHeader}>
                  <span
                    className={
                      !this.state.editUnscheduled
                        ? styles.negativeMarginTitle
                        : styles.title
                    }
                  >
                    {this.props.t("LeadTimes.inTransit")}
                  </span>
                  <HasPermissionTo
                    perform={["leadTimes:write"]}
                    permissions={this.props.user.permissions.rolePermissions}
                    condition={
                      !this.state.editInTransit &&
                      !this.props.fromNscDealerSearch
                    }
                    render={() => {
                      return (
                        <div className={styles.editIcon}>
                          <EditIcon
                            id="InTransit"
                            onClick={() => this.handleEdit("InTransit")}
                          />
                        </div>
                      );
                    }}
                  />
                </Grid>
                <Grid item xs={1} className={styles.editHeader}>
                  <span
                    className={
                      !this.state.editUnscheduled
                        ? styles.negativeMarginTitle
                        : styles.title
                    }
                  >
                    {this.props.t("LeadTimes.vehicleHoldingCompound")}
                  </span>
                  <HasPermissionTo
                    perform={["leadTimes:write"]}
                    permissions={this.props.user.permissions.rolePermissions}
                    condition={
                      !this.state.editVehicleHoldingCompound &&
                      !this.props.fromNscDealerSearch
                    }
                    render={() => {
                      return (
                        <div className={styles.editIcon}>
                          <EditIcon
                            id="VHC"
                            onClick={() =>
                              this.handleEdit("VehicleHoldCompound")
                            }
                          />
                        </div>
                      );
                    }}
                  />
                </Grid>
                <Grid item xs={1} className={styles.editHeader}>
                  <span
                    className={
                      !this.state.editUnscheduled
                        ? styles.negativeMarginTitle
                        : styles.title
                    }
                  >
                    {this.props.t("LeadTimes.dealerDelivered")}
                  </span>
                  <HasPermissionTo
                    perform={["leadTimes:write"]}
                    permissions={this.props.user.permissions.rolePermissions}
                    condition={
                      !this.state.editDealerDelivered &&
                      !this.props.fromNscDealerSearch
                    }
                    render={() => {
                      return (
                        <div className={styles.editIcon}>
                          <EditIcon
                            id="DealerDelivered"
                            onClick={() => this.handleEdit("DealerDelivery")}
                          />
                        </div>
                      );
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          </div>
          <Grid container className={styles.countDiv}>
            <Grid item xs={1} />
            <Grid item xs={2}>
              <span className={styles.count}>{this.state.totalChecked} </span>
              model line{this.state.totalChecked !== 1 && "s"} selected
            </Grid>
          </Grid>
          <ValidatorForm onSubmit={this.handleSubmit} ref={this.formRef}>
            {this.state.data.map((data, index) => {
              return (
                <LeadTimesRow
                  user={this.props.user}
                  data={data}
                  index={index}
                  key={index}
                  infoTooltipOpen={this.state.infoTooltipOpen}
                  infoTooltipColumn={this.state.infoTooltipColumn}
                  closeInfoTooltip={this.closeInfoTooltip}
                  firstLoad={this.state.firstLoad}
                  handleKeyDown={this.handleKeyDown}
                  handleChange={this.handleChange}
                  editModeUnscheduled={this.state.editUnscheduled}
                  editModeInProduction={this.state.editInProduction}
                  editModeGateRelease={this.state.editGateReleased}
                  editModeInTransit={this.state.editInTransit}
                  editModeVehicleHoldingCompound={
                    this.state.editVehicleHoldingCompound
                  }
                  editModeDealerDelivered={this.state.editDealerDelivered}
                />
              );
            })}
            <HasPermissionTo
              perform={["leadTimes:write"]}
              permissions={this.props.user.permissions.rolePermissions}
              render={() => {
                return (
                  <div className={styles.buttonDiv} data-testid="savedMsg">
                    {this.state.saveSuccess ? (
                      <div className={styles.saveSuccess}>
                        {this.state.totalSaved}{" "}
                        {this.state.totalSaved !== 1
                          ? this.props.t("LeadTimes.savedMultiple")
                          : this.props.t("LeadTimes.savedOne")}
                      </div>
                    ) : (
                      <button
                        type="submit"
                        data-testid="submitBtn"
                        disabled={
                          this.state.buttonDisabled || isFromNscDealerSearch
                        }
                      >
                        {this.props.t("LeadTimes.releaseLeadTimes")}
                      </button>
                    )}
                  </div>
                );
              }}
            />
          </ValidatorForm>
        </div>
      </div>
    );
  }
}

export default withTranslation("emp")(LeadTimes);
